<template>
  <FeatureDetailPage feature-key="retainers-and-recurring-billing" />
</template>
